import React from 'react';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

export default function SimpleMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            label: {
              color: "#f1f1f1",
            }
          }
        }
      }
    }
  });

  return (
    <div>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            Menu
        </Button>
        </ThemeProvider>
      </StyledEngineProvider>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component={Link} to="/">Home</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/bio">Biography</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/contact" >Contact Me</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/events" >Events</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/photos" >Photo Gallery</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/radio" >Radio</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/support" >Support</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/saturday" >Saturday Concerts</MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/videos" >Video Gallery</MenuItem>
        <MenuItem onClick={handleClose}><a target="_blank" href="mpv1/index.html">Mysterious Pathways Volume One</a></MenuItem>
      </Menu>
    </div>
  );
}

/*
<nav id="menu">
        <ul id="links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="bio">Biography</Link></li>
          <li><Link to="gallery">Videos</Link></li>
          <li><Link to="photos">Photos</Link></li>
          <li><Link to="support">Support</Link></li>
          <li><Link to="saturday">Saturday Concerts</Link></li>
          <li><a target="_blank" href="mpv1/index.html">Mysterious Pathways Volume One</a></li>
        </ul>
      </nav>
      */